import { StatTableComponent } from './stat-table.component';
import { scCoreModule } from '../core/core.module';
import { PieComponent } from './pie.component';
import { TreeComponent } from './tree.component';
import { ChartComponent } from './chart.component';
import { StatMenuComponent } from './stat-menu.component';

export const scStatModule = 'sc-stat';

angular.module(scStatModule, [scCoreModule])
  .component('scStatTable', StatTableComponent)
  .component('scPie', PieComponent)
  .component('scChart', ChartComponent)
  .component('scTree', TreeComponent)
  .component('scStatMenu', StatMenuComponent);



// WEBPACK FOOTER //
// ./src/stat/stat.module.js